export const rootElementId = 'advice-robo-pcs';